import React from 'react';
import ProgressBar from 'ps-react-chadacious/ProgressBar';

/** 100% progress */
export default function Example100Percent() {
    return <ProgressBar percent={100} width={150} height={20} />
}


// WEBPACK FOOTER //
// ./src/docs/examples/ProgressBar/Example100Percent.js